function initFairlyMade() {

    //Get the modal
    var modalFairlyMade = document.getElementById("modal_fairly_made");
    // Get the <span> element that closes the modal
    var span = document.getElementsByClassName("fairly_made_close")[0];
    // When the user clicks on the button, open the modal
    openModalFairlyMade = function () {
      modalFairlyMade.style.display = "block";
    }
    // When the user clicks on <span> (x), close the modal
    span.onclick = function () {
      modalFairlyMade.style.display = "none";
    }
    // When the user clicks anywhere outside of the modal, close it
    document.body.onclick = function (event) {
      if (event.target == modalFairlyMade) {
        modalFairlyMade.style.display = "none";
      }
    }

   }
   
   initFairlyMade();